<template>
  <RevCard class="p-24">
    <h2 class="heading-2 mb-8">{{ i18n(translations.title) }}</h2>
    <div class="flex flex-row items-center">
      <div class="flex-1">
        <p class="body-1 mb-20">
          {{ i18n(translations.subtitle) }}
        </p>
        <RevButton
          :icon="IconChevronRight"
          size="small"
          :to="QUALITY_CHARTER_LINK"
          variant="secondary"
        >
          {{ i18n(translations.tellMeMore) }}
        </RevButton>
      </div>
    </div>
  </RevCard>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import { getExternalLinkList } from '~/constants/externalLinks'

import translations from './QualityCharter.translations'

const i18n = useI18n()

const { QUALITY_CHARTER_LINK } = getExternalLinkList(i18n.currentLocale)
</script>
